module.exports = __webpack_public_path__ + "img/tote bag.0945a39c.svg";